"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WriteOffRequest = void 0;
var WriteOffRequest = /** @class */ (function () {
    function WriteOffRequest() {
    }
    return WriteOffRequest;
}());
exports.WriteOffRequest = WriteOffRequest;
//# sourceMappingURL=writeOff.request.js.map